import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazySources = lazy(() => import('./SourceDetail'));

export const SourceDetail: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazySources {...props} />
	</Suspense>
);
